export default __webpack_public_path__ + "static/media/used-cubicles-teknion-1.fdb53ef6.jpg";